function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { useTranslation } from 'next-i18next';
import { AppointmentType } from 'src/@types/Appointment';
import { DataTestIds } from 'src/config/dataTestIds';
import * as S from './AppointmentCard.styles';
export let AppointmentCardAction = /*#__PURE__*/function (AppointmentCardAction) {
  AppointmentCardAction["Book"] = "BOOK";
  AppointmentCardAction["Cancel"] = "CANCEL";
  AppointmentCardAction["Reschedule"] = "RESCHEDULE";
  return AppointmentCardAction;
}({});
const AppointmentCard = ({
  type,
  title,
  children,
  selected,
  extra,
  showSelectedArrow,
  onClick,
  referenceId,
  actionBar,
  ...rest
}) => {
  const {
    t
  } = useTranslation();
  const buttons = actionBar?.actions?.map(action => {
    if (actionBar?.onBook && action === AppointmentCardAction.Book) {
      return /*#__PURE__*/React.createElement(S.Button, {
        key: referenceId + 'book',
        onClick: e => {
          e.stopPropagation();
          actionBar?.onBook();
        }
      }, t('b2c.appointments.book_new'));
    }
    if (action === AppointmentCardAction.Reschedule) {
      return /*#__PURE__*/React.createElement(S.Button, {
        key: referenceId + 'reschedule',
        onClick: e => {
          e.stopPropagation();
          actionBar?.onReschedule();
        }
      }, t('b2c.appointments.reschedule'));
    }
    if (action === AppointmentCardAction.Cancel) {
      return /*#__PURE__*/React.createElement(S.Button, {
        key: referenceId + 'cancel',
        onClick: e => {
          e.stopPropagation();
          actionBar?.onCancel();
        }
      }, t('b2c.buttons.cancel'));
    }
  });
  const renderButton = (button, index) => /*#__PURE__*/React.createElement(S.Wrapper, {
    key: `${index}_action_button`
  }, button);
  return /*#__PURE__*/React.createElement(S.Root, _extends({
    type: type,
    "data-testid": DataTestIds.AppointmentCard,
    "data-referenceid": referenceId,
    "data-canceled": type === AppointmentType.Canceled,
    onClick: onClick ? onClick : undefined,
    selected: selected
  }, rest), /*#__PURE__*/React.createElement(S.Header, {
    type: type,
    selected: selected
  }, /*#__PURE__*/React.createElement(S.Meta, null, /*#__PURE__*/React.createElement(S.Title, null, title)), /*#__PURE__*/React.createElement(S.MetaExtra, null, extra), showSelectedArrow && /*#__PURE__*/React.createElement(S.ArrowIcon, {
    visible: selected
  })), /*#__PURE__*/React.createElement(S.Content, null, children), buttons.filter(b => !!b).length > 0 && /*#__PURE__*/React.createElement(S.Actions, null, buttons.map(renderButton)));
};
export default AppointmentCard;